import React, { useState } from "react";
import { SelectIcon } from "App/Assets";
import { useDatatables } from "App/hooks";
import { TableRow, TableCell } from "@material-ui/core";
// import { TableRowRuangRsOL } from "../TabRuangRsOL/TabRuangRsOL";
import { Grid, makeStyles, CircularProgress } from "@material-ui/core";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import {
  InputCheckboxMaster,
  Modal,
  TableWrapper,
  IconButtonDatatable,
  TableCellDefault,
  TableAction
} from "App/Component/ui";

const useStyles = makeStyles(() => ({
  modalContainer: {
    position: 'relative',
    minHeight: '200px',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    width: '40px !important',
    height: '40px !important',
    borderRadius: '50% !important',
  }
}));

function ModalKlsRsOL({
  setShowModal,
  handleClickAddKlsSirsOL,
  rowsKlsSirsOL,
  rows,
  handleClickDeleteKlsSirsOl,
  stateUpdate,
  setStateUpdate,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleAction = async (action, row) => {
    setLoading(true);
    try {
      await action(row);
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title="Ruang Mapping RS OL" width={"80%"} show={setShowModal}>
      <div className={classes.modalContainer}>
        {loading && (
          <div className={classes.loadingOverlay}>
            <CircularProgress className={classes.spinner} />
          </div>
        )}

        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={stateUpdate}
              name="update_rs_online"
              id="update_rs_online"
              label="Update RS OL"
              onChange={(e) => {
                setStateUpdate(!stateUpdate);
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <TableListKlsSirsOl
              rows={rows}
              clickSelect={(row) => handleAction(handleClickAddKlsSirsOL, row)}
              isSelect={true}
              isUpdate={false}
              title="Ruang"
              setLoading={setLoading}
            />
          </Grid>
          <Grid item sm={6}>
            <TableListKlsSirsOl
              rows={rowsKlsSirsOL}
              clickDelete={(row) => handleAction(handleClickDeleteKlsSirsOl, row)}
              isSelect={false}
              isUpdate={false}
              title="Ruang RS Gol Kelas"
            />
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

const TableListKlsSirsOl = ({
  rows,
  clickSelect,
  clickDelete,
  isSelect,
  isUpdate,
  title,
}) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  return (
    <TableWrapper
      title={title}
      setQ={setQ}
      withAddButton={false}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
    >
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRowRuangForRsOL
              index={index}
              row={row}
              isSelect={isSelect}
              isUpdate={isUpdate}
              clickSelect={clickSelect}
              clickDelete={clickDelete}
              key={index}
            />
          );
        })}
    </TableWrapper>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

const TableRowRuangForRsOL = ({
  isSelect = false,
  isDelete = true,
  isUpdate = true,
  row,
  clickDelete,
  clickUpdate,
  clickSelect,
  index,
}) => {
  return (
    <TableRow
      hover
      tabIndex={-1}
      key={index}
      style={{
        backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
      }}
    >
      <TableCell component='th' scope='row' padding='none' align='center'>
        {index + 1}
      </TableCell>
      <TableCell component='th' scope='row' padding='none' width={"5%"}>
        {isSelect ? (
          <IconButtonDatatable onClick={() => clickSelect(row)}>
            <SelectIcon width={"16"} height={"16"} fill={"#fff"} />
          </IconButtonDatatable>
        ) : (
          <TableAction
            clickDelete={() => clickDelete(row)}
            clickUpdate={() => clickUpdate(row)}
            isDelete={isDelete}
            isUpdate={isUpdate}
          />
        )}
      </TableCell>
      <TableCell align='left'>{row?.id}</TableCell>
      <TableCell align='left' width={"5%"}>{row?.kode_sirsonline}</TableCell>
      <TableCell align='left'>{row?.name}</TableCell>
      <TableCellDefault row={row} />
    </TableRow>
  );
};

export default ModalKlsRsOL;
